import { Drawer } from "@mui/material";
import MDBox from "components/MDBox";
import { ReactNode } from "react";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import UiButton from "./UiButton";
import UiTypography from "./UiTypography";

type UiSideModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  width?: string;
  children: ReactNode;
  onConfirm?: () => void;
  confirmLabel?: string;
};

export default function UiSideModal({
  open,
  onClose,
  title,
  width = "498px",
  children,
  onConfirm,
  confirmLabel = "Save",
}: UiSideModalProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width,
          maxWidth: "100vw",
          height: "100%",
          borderRadius: 0,
          m: 0,
          borderLeft: `1px solid ${draftColors.border}`,
          boxShadow: "-8px 0px 24px rgba(15, 23, 42, 0.08)",
        },
      }}
    >
      <MDBox display="flex" flexDirection="column" height="100%">
        <MDBox
          minHeight="81px"
          px="24px"
          py="24px"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          borderBottom={`1px solid ${draftColors.border}`}
        >
          <UiTypography uiVariant="heading-lg" sx={{ color: "#212936" }}>
            {title}
          </UiTypography>
          <UiButton uiVariant="outlined" onClick={onClose}>
            Close
          </UiButton>
        </MDBox>

        <MDBox flex={1} overflow="auto">
          {children}
        </MDBox>

        {onConfirm && (
          <MDBox px="24px" py="12px" display="flex" justifyContent="flex-end" gap="8px">
            <UiButton uiVariant="primary-blue" onClick={onConfirm}>
              {confirmLabel}
            </UiButton>
          </MDBox>
        )}
      </MDBox>
    </Drawer>
  );
}
